import {Alert, Breadcrumb, Button} from "antd";
import {Link} from "react-router-dom";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";
import {ErrorBoundary} from "react-error-boundary";
import {CreateBundleMultiStepFormWrapper} from "../../../../calls/useCases/createBundle/multi-step/multi-step-form-wrapper";
import {CanvaTemplateWidget} from "../../../../components/widgets/canva-template-widget";
import {CreateBundleContextWrapper} from "../../../../calls/useCases/createBundle/context/create-bundle/context-wrapper";
import {StyledHideStepsOnMobile} from "../../../../components/offering-form/general/steps/styles";
import {CreateBundleFormSteps} from "../../../../calls/useCases/createBundle/multi-step/create-bundle-steps";

const AddBundlePage = () => {
  const pageTitle = "Create new bundle";
  return (
    <DashboardWrapper pageTitle={pageTitle}>
      <CreateBundleContextWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/calls">1:1 Sessions</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create new bundle</Breadcrumb.Item>
        </Breadcrumb>
        <StyledPageWrapper>
          <div className="main-area">
            <ErrorBoundary
              FallbackComponent={({error, resetErrorBoundary}) => (
                <div>
                  <Alert
                    message="Sorry, something went wrong."
                    showIcon
                    description={error.message}
                    type="error"
                    action={
                      <Button
                        onClick={() => {
                          resetErrorBoundary();
                        }}
                        size="small"
                        danger
                      >
                        Reset
                      </Button>
                    }
                  />
                </div>
              )}
            >
              <CreateBundleMultiStepFormWrapper />
            </ErrorBoundary>
          </div>
          <div className="widget-area">
            <StyledHideStepsOnMobile>
              <CreateBundleFormSteps />
            </StyledHideStepsOnMobile>
            <CanvaTemplateWidget url="https://www.canva.com/design/DAGOSXnkoPE/5Fg__pLqNu6jl-cliuexgQ/view?utm_content=DAGOSXnkoPE&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink&mode=preview" />
          </div>
        </StyledPageWrapper>
      </CreateBundleContextWrapper>
    </DashboardWrapper>
  );
};

export {AddBundlePage};
